export default {"src":"/_next/static/media/huawei_logo.86652d64.svg","height":168,"width":564,"blurWidth":0,"blurHeight":0};